/* ==================================================================
 *  settings
 *  定数の管理
 * ================================================================== */
const pc_404_selector = "body.pc.application.render_404";
const pc_500_selector = "body.pc.application.render_500";
const bookmark_recent_selector = "body.search.bookmark, body.search.recent";

const user_default_img =
  // eslint-disable-next-line max-len
  "data:image/gif;base64,R0lGODdhWgBaALMAAAAAALe3t729vcXFxcrKytPT09vb2+Pj4+7u7vT09P///wAAAAAAAAAAAAAAAAAAACH5BAQAAAAALAAAAABaAFoAAAT/cMhJq7046827/2AojmRpnmiqrmzrvnAszzRFTEKtW/cg5JffhNDbmYgVIeGASCieicTB0BMOikaUYOl8er9Qqi/LMiDAaDCCar1iyZrbb5muqwvjN3yTM3TtgApSY4R7GHIDB4GLXgeFhhsGjJMKjleQGDmKlJOOQJgWfpyUBlugEnIFf6OMRXp7m6yBXQhDp5KynAaop2e5lAkEn4YCqr+clqC+x5MJpwSrzLMFppdkuNKdw1ma2cCPRjnL3rMDAXs50eR2wugE65N47vCM8nBb9Iv2RnLQ+YCvdGxR9w9KwBhFBhZME4zYgHELn9TCFCvikwPbuImy+IQapC0Q/wsGy8it4sKJkIS94yjvYI0tJvMh6OFSx8qFHnntESYg5DoEOWruUJgvQc5TEooRlGZJ6A45MZklYIM0CQFs2TzZwIQk6YCNzLRecPqyWNRmCKgFrZqpmE9GM5XMqZqwz1tGUsSQ5OoD5lJWU3las3VvQIGzUg8IBuV34dRHZFm45VgpMgtEWDka3StjS2bKjzlb3tAPMcddhGGApAwINUIfBO6yvjjjh+nZtNe6+Iw7jdqtKQr0xttOcuzhcEfHkSAb+RfXKYo5b3a0RLvm073U4vxBwO3sz7l3SAd+0nYTAniXZwhdBPn1yUn0gU/KOnb6tEkIx09cPIbv/D1RimUI/gS4CFAhSGdgK/5RkN6CjAwIwn0LYuSBSn9B6IUzDfpgjIaB3ODUgyAGUp0G3pVoYoc9qdhaBS5RCCFKHWSoIo2k2VgiSjUV6GIaM13IRBMJEInAkUgmqeSSTDbp5JNODnJBBAA7";

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する
window.pc_404_selector = pc_404_selector;
window.pc_500_selector = pc_500_selector;
window.bookmark_recent_selector = bookmark_recent_selector;
window.user_default_img = user_default_img;

export {
  pc_404_selector,
  pc_500_selector,
  bookmark_recent_selector,
  user_default_img,
};
